/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import Select from 'react-select'
import {initialQueryState, KTIcon, useDebounce} from '../../../../../_metronic/helpers'
import {ISelect} from '../../../../../coreGlobal/models/default'
import {useQueryRequest} from '../../../core/QueryRequestProvider'
import {getFranchises} from '../../../core/_request'

const Search = () => {
  const {updateState} = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [franchises, setFranchises] = useState<ISelect[]>([])

  // Debounce para só chamar a API quando o usuário parar de digitar
  const debouncedSearchTerm = useDebounce(searchTerm, 300)

  useEffect(() => {
    getFranchises()
      .then((data) => setFranchises(data))
      .catch(() => setFranchises([]))
  }, [])

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
      updateState({name: debouncedSearchTerm, ...initialQueryState})
    }
  }, [debouncedSearchTerm])

  return (
    <div className='card-title flex-wrap'>
      <div className='d-flex flex-wrap align-items-center position-relative my-1 gap-4'>
        <div className='position-relative'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute top-50 translate-middle-y ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='name'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Pesquisar sala'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className='w-250px'>
          <Select
            className='react-select-styled react-select-solid'
            classNamePrefix='react-select'
            options={franchises}
            isClearable
            placeholder='Todas as franquias'
            noOptionsMessage={() => 'Nenhuma franquia encontrada'}
            onChange={(option) =>
              updateState({franchises: option ? String(option.value) : '', ...initialQueryState})
            }
          />
        </div>
      </div>
    </div>
  )
}

export {Search}
